<template>
  <div class="campus-manage-container" @touchmove.prevent>
    <div class="campus-calendar-content w-transition" :class="{ 'half-screen-calendar': (fullScreenCalendar === 1), 'full-screen-calendar': (fullScreenCalendar === 2) }"
    >
     <!-- @touchstart="touchstart" @touchend="touchend"> -->
      <!-- v-touch:swipeup="changeFullScreenState" v-touch:swipedown="changeFullScreenState"> -->
      <p class="current-month">{{ currentMonth.dateFormatFont }}
        <i class="iconfont iconzuoqie" @click="rightScroll()"></i>
        <i class="iconfont iconyouqie" @click="leftScroll()"></i>
      </p>
      <div class="week-font-content flex-between">
        <template v-for="(item, index) in weekFont">
          <div class="week-font-item flex-center" :key="index">{{ item }}</div>
        </template>
      </div>
      <transition name="fade">
        <calendar-week ref="calendarWeek" @sameMonth="sameMonth" @calendarMove="calendarMove" @calendarClick="calendarClick" v-show="fullScreenCalendar === 0" :leftFlag="scrollFlagOption.leftFlagWeek" :rightFlag="scrollFlagOption.rightFlagWeek">
          <template v-for="(item, index) in currentWeek">
            <div v-if="item.infos && item.infos.length" class="week-things-point" :class="`${item.infos[0].type}-point`" :key="index" :slot="item.date"></div>
          </template>
        </calendar-week>
      </transition>
      <transition name="fade">
        <calendar-month-half ref="calendarMonth"
                        :leftFlag="scrollFlagOption.leftFlagMonthHalf"
                        :rightFlag="scrollFlagOption.rightFlagMonthHalf"
                        :activeTranslateIndex="activeTranslateIndex"
                        @calendarMove="calendarMove"
                        @calendarMonthClick="calendarMove"
                        @changeCurrentMonth="changeCurrentMonthHalf"
                        @calendarClick="calendarClick"
                        @changeTranslateX="changeTranslateX"
                        v-show="fullScreenCalendar === 1">
          <div v-for="(item, index) in monthThingsData[currentMonth.dateMonthKey]" :key="index" :slot="item.date">
            <div v-if="item.infos && item.infos.length" class="week-things-point" :class="`${item.infos[0].type}-point`"  :slot="item.date"></div>
          </div>
        </calendar-month-half>
      </transition>
      <transition name="fade">
        <calendar-month ref="calendarMonth"
                        :leftFlag="scrollFlagOption.leftFlagMonth"
                        :rightFlag="scrollFlagOption.rightFlagMonth"
                        :activeTranslateIndex="activeTranslateIndex"
                        @calendarMove="calendarMove"
                        @calendarMonthClick="calendarMove"
                        @changeCurrentMonth="changeCurrentMonth"
                        @calendarClick="calendarClick"
                        @changeTranslateX="changeTranslateX"
                        v-show="fullScreenCalendar === 2">
          <div v-for="(item, index) in monthThingsData[currentMonth.dateMonthKey]" :key="index" :slot="item.date">
            <template v-for="(val, tIndex) in item.infos">
              <div class="things-item flex-center" :key="tIndex" v-if="tIndex < showItemMaxIndex"
                   :class="[`finished-${val.finished}`, `${val.type}`, {'more-comp-recruit': tIndex === showItemMaxIndex - 1 && item.infos.length > showItemMaxIndex}]">
                {{val.comp_name | stepTypeFilter(item.infos, tIndex, showItemMaxIndex)}}
              </div>
            </template>
          </div>
        </calendar-month>
      </transition>
      <div class="calendar-directive" @touchstart="touchstart" @touchend="touchend" :style="fullScreenCalendar !== 0 && 'paddingTop: 20px;'">
        <span></span>
      </div>
    </div>
    <div class="campus-calendar-deal flex-start" :class="{'deal-system-active': dealType === 'system'}">
      <div class="deal-item" :class="{'deal-item-active': dealType === 'me'}" @click="changeDealType('me')">我的待办</div>
      <div class="deal-item" :class="{'deal-item-active': dealType === 'system'}" @click="changeDealType('system')">网申日程</div>

      <div v-if="!clockFlag" class="clock-btn open-btn" @click="toNewPage()">开启闹钟</div>
      <div v-else class="clock-btn close-btn">已经开启闹钟</div>
    </div>
    <!-- <div class="add-thing-to-do flex-center" @click="toCreateThings" v-show="weekThingsData[currentSunday] && weekThingsData[currentSunday][dealType].length"> -->
    <div class="add-thing-to-do flex-center" @click="toCreateThings">
      <i class="iconfont iconcvs-chuangjian"></i>
    </div>
    <template v-if="weekThingsData[currentSunday]">
      <div class="thing-scroll-container" v-if="weekThingsData[currentSunday][dealType].length">
        <cube-scroll ref="scroll" :data="weekThingsData[currentSunday][dealType]" :options="scrollOptions">
          <things-list :listData="weekThingsData[currentSunday][dealType]" :type="dealType"/>
        </cube-scroll>
      </div>
    </template>
    <campus-nothing :deal-type="dealType" v-show="weekThingsData[currentSunday] && !weekThingsData[currentSunday][dealType].length" @addThings="createCampusRecruitment" :style="fullScreenCalendar === 1 ? 'paddingTop: 66px;' : 'paddingTop: 140px;'" />

  </div>
</template>

<script>
import manageCalendar from '../../components/manage-calendar'
import calendarWeek from '../../components/calendar-week'
import calendarMonth from '../../components/calendar-month'
import calendarMonthHalf from '../../components/calendar-month-half'
import campusNothing from '../../components/campus-nothing'
import thingsList from '../../components/things-list'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { loginMixin, envMixin } from '../../../../assets/js/mixin/global'

const moment = require('moment')

export default {
  mixins: [loginMixin, envMixin],
  name: 'campus-calendar-manage',
  data () {
    return {
      moment,
      // fullScreenCalendar: false, //是否是全屏的日历
      fullScreenCalendar: 1, // 0：顶部 1：中间 2：全屏
      weekFont: ['日', '一', '二', '三', '四', '五', '六'], //日历头部的星期
      dealType: 'me',
      scrollOptions: {},
      showItemMaxIndex: 3,
      startX: null,
      startY: null, // 鼠标 touchstart 时的位置
      timer: null,
      duration: 0, // 记录滑动开始到结束的时间间隔，因为子组件 click 时间会触发 touchstart 和 touchend ，所以通过时间间隔来判断是冒泡还是滑动
      activeTranslateIndex: -10,
      scrollFlagOption: {
        // 周日历
        leftFlagWeek: false,
        rightFlagWeek: false,

        // 半月日历
        leftFlagMonthHalf: false,
        rightFlagMonthHalf: false,

        // 全月日历
        leftFlagMonth: false,
        rightFlagMonth: false

      },
      lock: false,
      clockFlag: false, // 闹钟提醒是否开启
      newPageLink: 'https://mp.weixin.qq.com/s/FVcFkx7vGHYlVfPyo4cTJg' // 裂变页地址
    }
  },
  async created () {
    this.getApplication()
    await this.loginByWx()
    await this.initThingsData()
    this.calendarClick(moment().format('YYYY-MM-DD'))
  },
  activated() {
    this.initThingsData()
  },
  components: {
    manageCalendar,
    calendarWeek,
    calendarMonth,
    calendarMonthHalf,
    campusNothing,
    thingsList
  },
  watch: {
    fullScreenCalendar(newVal, oldVal) {
      const refType = newVal ? 'calendarMonth' : 'calendarWeek'
      if (!this.isClick) {
        this.$refs[refType].calcCurrentMonth()
      }
    },
    'currentMonth.dateMonthKey'(newVal, oldVal) {
      if (!this.monthThingsData[newVal]) {
        this.getMonthThingsData()
      }
    },
    currentSunday(newVal, oldVal) {
      if (!this.weekThingsData[newVal]) {
        this.getWeekThingsData()
        this.calendarClick(newVal)
      }
    }
  },
  computed: {
    ...mapState('campusOffers', ['isClick', 'fullMonthData', 'fullWeekData', 'monthThingsData', 'weekThingsData', 'currentSunday']),
    ...mapGetters('campusOffers', ['currentMonth']),
    currentWeek() {
      if (this.weekThingsData[this.currentSunday]) {
        let data = JSON.parse(JSON.stringify(this.weekThingsData[this.currentSunday]))
        let { me, system } = data
        me.forEach(item => {
          const systemInfo = system.find(val => val.date === item.date)
          if (systemInfo) {
            item.infos = [ ...item.infos, ...systemInfo.infos ]
          }
        })
        const campusRecruitings = system.filter(item => {
          const meItem = me.find(val => val.date === item.date)
          if (!meItem) return item
        })
        return [ ...me, ...campusRecruitings ]
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations('campusOffers', {
      setClickMonthStr: 'SET_CLICK_MONTH_STR',
      setDefaultDateStr: 'SET_DEFAULT_DATE_STR',
      setMonthThingsData: 'SET_MONTH_THINGS_DATA',
      setCurrentSunday: 'SET_CURRENT_SUNDAY'
    }),
    ...mapActions('campusOffers', ['getMonthThingsData', 'getWeekThingsData']),

    async toNewPage () {
      if (this.isWxMini) {
        let res = await this.$api.jobs.getTeamInfo()
        let completed = false
        if(res.code === 1000){
          completed = res.data.completed
          if(!completed){
            if (this.isWxMini) {
              this.$wechat.miniProgram.navigateTo({
                url: `/pages/fission/fission`
              })
              return
            }
          }
        }
        Promise.all([this.$api.jobs.changeNetApplication({
          type: 'wechat_self_net_application',
          status: 'on'
        }),this.$api.jobs.changeNetApplication({
          type: 'wechat_all_net_application',
          status: 'on'
        }),this.$api.jobs.changeNetApplication({
          type: 'wechat_to_do_net_application',
          status: 'on'
        })]).then(res => {
          this.clockFlag = true;
        })
      } else {
        window.location.href = this.newPageLink
      }
    },
    async getApplication () {
      let res = await this.$api.jobs.getNetApplication()
      if (res.code === 1000) {
        this.clockFlag = res.data.wechat_all_net_application_status && res.data.wechat_self_net_application_status && res.data.wechat_to_do_net_application_status
      }
    },
    leftScroll () {
      let index = this.fullScreenCalendar
      if (index === 0) {
        this.scrollFlagOption.leftFlagWeek = !this.scrollFlagOption.leftFlagWeek
      } else if (index === 1) {
        this.scrollFlagOption.leftFlagMonthHalf = !this.scrollFlagOption.leftFlagMonthHalf
      } else if (index === 2) {
        this.scrollFlagOption.leftFlagMonth = !this.scrollFlagOption.leftFlagMonth
      }
    },
    rightScroll () {
      let index = this.fullScreenCalendar
      if (index === 0) {
        this.scrollFlagOption.rightFlagWeek = !this.scrollFlagOption.rightFlagWeek
      } else if (index === 1) {
        this.scrollFlagOption.rightFlagMonthHalf = !this.scrollFlagOption.rightFlagMonthHalf
      } else if (index === 2) {
        this.scrollFlagOption.rightFlagMonth = !this.scrollFlagOption.rightFlagMonth
      }
    },
    changeTranslateX(length) {
      this.showItemMaxIndex = length > 35 ? 2 : 3
    },
    createCampusRecruitment() {
      if (this.dealType === 'me') {
        this.toCreateThings()
      } else {
        if (this.isWxMini) {
          this.$wechat.miniProgram.switchTab({
            url: '/pages/campusOffersList/campusOffersList'
          })
        } else {
          this.$router.replace('/jobs/campus/offers')
        }
      }
    },
    // 跳转创建待办
    toCreateThings() {
      if (this.alreadyLogged) {
        this.$router.push({
          path: '/jobs/campus/thing/create'
        })
      } else {
        this.needLogin()
      }
    },
    changeCurrentMonth () {
      this.fullScreenCalendar = 0
    },
    changeCurrentMonthHalf () {},
    touchstart (e) {
      // 开始记录时间间隔
      // this.timer = setInterval(() => {
      //   this.duration += 0.01
      // }, 10)
      // 获取 touchstart 的鼠标位置并存储
      let startY = e.changedTouches[0].clientY
      let startX = e.changedTouches[0].clientX
      this.startY = startY
      this.startX = startX
    },
    touchend (e) {
      if (this.lock) return
      this.lock = true
      // // 关闭定时器
      // clearInterval(this.timer)
      // // 间隔小于0.1s，判断为子元素 click 冒泡，所以不进行后续处理
      // if (this.duration < 0.1) {
      //   this.duration = 0
      //   return
      // }

      let startY = this.startY
      let startX = this.startX
      // 获取 touchend 的鼠标位置
      let endY = e.changedTouches[0].clientY
      let endX = e.changedTouches[0].clientX
      // 如果鼠标水平方向差距过大，则return
      // if (Math.abs(startX - endX) > 30){
      //   this.lock = false
      //   return
      // }
      if (startY >= endY) {
        this.changeFullScreenState(-1)
      } else {
        this.changeFullScreenState(1)
      }
      this.duration = 0
      this.lock = false
    },
    // week和month 的日历切换
    // changeFullScreenState() {
    //   this.fullScreenCalendar = !this.fullScreenCalendar
    // },
    changeFullScreenState(direction) {
      let activeIndex = this.fullScreenCalendar
      if (activeIndex === 0 && direction === -1) return
      if (activeIndex === 2 && direction === 1) return
      activeIndex = activeIndex + direction
      this.fullScreenCalendar = activeIndex
      this.$forceUpdate
    },
    // 待办切换
    changeDealType(type) {
      this.dealType = type
    },
    // 日历切换时处理另外一个的移动位置
    calendarMove(fullDate, type, dateStr, translateIndex) {
      this.$refs[type].dealTranslateX(fullDate, type, dateStr)
      // 半月日历和全日历切换时，需要同步 translateIndex 值
      if (type === 'calendarWeek' && translateIndex) {
        this.activeTranslateIndex = translateIndex
      }
      // 移动周日历，需要同步月日历的月份
      if (type === 'calendarMonth') {
        // console.log(this.$refs[type].translateIndex, this.activeTranslateIndex, 'jjjjjjj')
        this.activeTranslateIndex = this.$refs[type].translateIndex
      }
    },
    sameMonth (fullDate, type, dateStr) {
      this.$refs[type].dealTranslateX(fullDate, type, dateStr)
      // console.log(this.$refs[type].translateIndex, this.activeTranslateIndex, 'wwwwww')
      this.activeTranslateIndex = this.$refs[type].translateIndex
    },
    // 点击周视图日历待办列表滚动
    calendarClick(currentDateStr) {
      this.$nextTick(() => {
        let scrollWrapperEl = document.querySelector('.thing-scroll-container')
        let scrollContent = document.querySelector('.cube-scroll-content')
        let el = document.getElementById(currentDateStr)
        if (el && this.$refs.scroll) {
          if (scrollContent.clientHeight < scrollWrapperEl.clientHeight) {
          } else if (el.offsetTop + scrollWrapperEl.clientHeight > scrollContent.clientHeight) {
            this.$refs.scroll.scrollTo(0, -scrollContent.clientHeight + window.innerHeight - 198, 300)
          } else {
            this.$refs.scroll.scrollTo(0, -el.offsetTop + 18, 300)
          }
        } else if (this.$refs.scroll) {
          const weekIndex = moment(currentDateStr).day()
          let otherEl
          let addDayNum = 1
          for (let i = weekIndex; i < 6; i++) {
            let str = moment(currentDateStr).add(addDayNum, 'days').format('YYYY-MM-DD')
            addDayNum += 1
            if (document.getElementById(str)) {
              otherEl = document.getElementById(str)
              break
            }
          }
          if (scrollContent.clientHeight < scrollWrapperEl.clientHeight) {
          } else if (otherEl && otherEl.offsetTop + scrollWrapperEl.clientHeight <= scrollContent.clientHeight) {
            this.$refs.scroll.scrollTo(0, -otherEl.offsetTop + 18, 300)
          } else {
            this.$refs.scroll.scrollTo(0, -scrollContent.clientHeight + window.innerHeight - 198, 300)
          }
        }
      })
    },
    // 初始化数据
    initThingsData() {
      document.title = '校招规划局'
      if (this.alreadyLogged) {
        this.getMonthThingsData()
        this.getWeekThingsData()
      }
    }
  },
  filters: {
    stepTypeFilter(val, things, index, showItemMaxIndex) {
      if (things.length > showItemMaxIndex && index === showItemMaxIndex - 1) {
        return '···'
      } else {
        return val ? val.slice(0, 3) : '网申'
      }
    }
  },
}
</script>
<style scoped lang="scss">
@import '../../../../assets/scss/global/variable';
@import '../../../../assets/scss/global/mixin';
.campus-manage-container {
  min-height: $screen-height;
  @include mobile-container(0, 1px);
  background-color: #F9F9F9;
  position: absolute;
  width: 100vw;
  .campus-calendar-content {
    // position: absolute;
    position: relative;
    background-color: $color-light;
    width: 100vw;
    height: 148px;
    padding: 20px 0 0;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 6px 10px 0 rgba($color: #8386a3, $alpha: 0.12);
    top: 0;
    z-index: 11;

    &.half-screen-calendar {
      height: 52vh;
    }

    .current-month {
      font-size: $font-size-large;
      color: $color-title;
      margin-bottom: 14px;
      padding: 0 18px;
      font-weight: 500;

      >i {
        color: #404040;
        font-size: 18px;

        &:first-of-type {
          margin-right: 14px;
          margin-left: 6px;
        }
      }
    }
    .week-font-content {
      color: #9c9c9c;
      // padding: 0 18px;
      .week-font-item {
        $width: 375px / 7;
        width: $width;
        height: 28px;
      }
    }
    .calendar-directive {
      width: 80px;
      padding-top: 10px;
      padding-bottom: 20px;
      text-align: center;
      // border: 1px solid red;
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);


      >span {
        display: inline-block;
        width: 32px;
        height: 3px;
        margin-bottom: 8px;
        border-radius: 1.5px;
        background-color: #ececec;
      }
    }
    .things-item {
      width: 46px;
      height: 18px;
      border-radius: 2px;
      background-color: $color-theme;
      color: $color-light;
      font-size: 10px;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .finished-0 {
      text-decoration: line-through;
      text-decoration-color: #BCBCBC;
      background-color: #f4f4f4;
      color: #BCBCBC;
    }
    .finished-1 {
      background-color: #FF9B84;
    }
    .system {
      background-color: #FFF6F4;
      color: $color-theme;
    }
    .more-comp-recruit {
      background-color: #f4f4f4;
      color: #cfcfcf;
      font-weight: 500;
      text-decoration: none;
      font-size: 18px;
    }
    .week-things-point {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: $color-theme;

      &.month {
        margin-top: 8px;
      }
    }
    .system-point {
      background-color: rgba($color: $color-theme, $alpha: .15);
    }
  }

  .full-screen-calendar {
    height: calc(calc(var(--vh, 1vh) * 100) - constant(safe-area-inset-bottom));
    height: calc(calc(var(--vh, 1vh) * 100) - env(safe-area-inset-bottom));
    border-radius: 0;
    box-shadow: none;
    position: absolute;
    z-index: 11;
    top: 0px;
    overflow: hidden;
    background-color: $color-light;
  }

  .campus-calendar-deal {
    position: relative;
    // margin-top: 168px;
    margin-top: 22px;
    padding: 0 18px;
    .deal-item {
      color: #9C9C9C;
      font-size: $font-size-medium-x;
      margin-right: 24px;
      font-weight: 500;
      &-active {
        color: $color-title;
      }
    }
    &::after {
      content: '';
      transition: all .3s;
      position: absolute;
      width: 16px;
      height: 3px;
      border-radius: 1.5px;
      background-color: $color-theme;
      top: 26px;
      left: 42px;
    }

    .clock-btn {
      position: absolute;
      right: 18px;
      text-align: center;

      &.open-btn {
        height: 26px;
        line-height: 26px;
        border-radius: 13px;
        padding: 0 12px;
        border: 1px solid #FF6644;
        font-size: 14px;
        font-weight: 400;
        color: #FF6644;

        >a {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &.close-btn {
        font-size: 14px;
        font-weight: 400;
        color: #404040;
        line-height: 14px;
      }
    }
  }
  .thing-scroll-container {
    height: calc(calc(var(--vh, 1vh) * 100) - constant(safe-area-inset-bottom) - 198px);
    height: calc(calc(var(--vh, 1vh) * 100) - env(safe-area-inset-bottom) - 198px);
    margin-top: 16px;
  }
  .deal-system-active::after {
    transition: all .3s;
    left: 130px;
  }
  .add-thing-to-do {
    position: fixed;
    bottom: 36px;
    right: 24px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    z-index: 199;
    background-image: linear-gradient(#ff9f79, #ff6644);
    box-shadow: 0px 6px 8px 0px rgba(255, 102, 68, 0.18);
    .iconfont {
      color: $color-light;
      font-weight: 600;
      font-size: 18px;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
